import { ROUTE_PARAMS } from 'constants/routeParamNames';

import { ROUTES_NEW_ROOT } from './routesRoot';

// kredity-new страницы, которые нужно редиректить на новые урлы, чтобы избежать 404 после перехода
export const LEGACY_KREDITY_NEW_WEB_ROUTES = {
  loansSeoLanding: ROUTES_NEW_ROOT,
  creditCardsSeoLanding: `${ROUTES_NEW_ROOT}/promo/karty`,

  // выдача
  loansOffers: `${ROUTES_NEW_ROOT}/offers`,

  // анкета
  newForm: `${ROUTES_NEW_ROOT}/anketa`,

  // MPL
  creditsFullDeal: `${ROUTES_NEW_ROOT}/full-deal`,
  completedDeal: `${ROUTES_NEW_ROOT}/full-deal/completed-deals/:${ROUTE_PARAMS.HASHED_DEAL_ID}`,
} as const;
